export default __webpack_public_path__ + "static/dudu-feature5-84075bb0e63f558e7898866bf432fab8.png";